"use client";

import { SupportButtonError } from "@/components/support-button-error";
import { ErrorButtonReset, StatusCodeError } from "@/components/error";
import { useEffect } from "react";
import posthog from "posthog-js";

export default function Error({
  error,
  reset,
}: {
  error: Error;
  reset: () => void;
}) {
  useEffect(() => {
    posthog.captureException(error);
  }, [error]);

  return (
    <StatusCodeError
      statusCode="500"
      actionButton={<ErrorButtonReset reset={reset} />}
      supportButton={<SupportButtonError errorMessage={error.message} />}
    />
  );
}
